

















































































































































import { Component, Mixins, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations, Actions } from '@/ts/store/Constants';
import FacilityData from '@/ts/FacilityData';
import BookFacilityConfirmationOverlay from '@/components/User/SharedFacilities/BookFacilityConfirmationOverlay.vue';
import BookFacilityDateOverlay from '@/components/User/SharedFacilities/BookFacilityDateOverlay.vue';
import BookFacilityTimeOverlay from '@/components/User/SharedFacilities/BookFacilityTimeOverlay.vue';
import SlideUpDialog from '@/components/NEW-STRUCTURE/mobile/dialogs/SlideUpDialog.vue';
import CurvedDialogCard from '@/components/NEW-STRUCTURE/mobile/layout/CurvedDialogCard.vue';
import CreditCardsDialog from '@/components/User/Wallet/CreditCardsDialog.vue';
import SlideToConfirm from '@/components/NEW-STRUCTURE/mobile/buttons/SlideToConfirm.vue';
import StringHelper from '@/mixins/StringHelper.vue';
import Order from '@/ts/Order';

@Component({
    components: {
        BookFacilityConfirmationOverlay,
        BookFacilityDateOverlay,
        BookFacilityTimeOverlay,
        SlideUpDialog,
        CurvedDialogCard,
        SlideToConfirm,
        CreditCardsDialog,
    },
    computed: {
        ...mapGetters({
            time: 'SharedFacilities/getFacilityBookingTime',
            bookFacilityDateOverlayVisibility: 'SharedFacilities/getBookFacilityDateOverlayVisibility',
            bookFacilityTimeOverlayVisibility: 'SharedFacilities/getBookFacilityTimeOverlayVisibility',
        }),
    },
})
export default class BookFacilityOverlay extends Mixins(StringHelper) {
    public date: any = null;
    public currentStep: number = 0;
    public showDialog: boolean = false;
    public bookingPeriod: object = {
        hourly: 'hour',
        daily: 'day'
    };

    constructor() {
        super();
    }

    public addCreditCard() {
        this.$store.commit(Mutations.SET_CHOOSE_PAYMENT_METHOD_BLOCK_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ADD_NEW_CARD_FORM_VISIBILITY, true)
        this.closeDialog();
    }

    public openDialog() {
        this.showDialog = true;
    }

    public closeDialog(card: any = null) {
        this.showDialog = false; 
        if(card)
            this.$store.commit(Mutations.SET_ACTIVE_CREDIT_CARD, card);
    }

    public clearAllFields() {
        this.$store.commit(Mutations.RESET_FACILITY_BOOKING_TIME);
        this.$store.commit(Mutations.SET_FACILITY_BOOKING_DATE, null);
        this.$store.commit(Mutations.SET_FACILITY_BOOKING_DURATION, '');
    }

    get fieldsCompleted(): boolean {
        if(this.bookingTime && this.bookingDate && this.activeCard) {
            return true;
        }
        return false;
    }

    get confirmButtonDisabled(): boolean {
        if(this.fieldsCompleted) {
            return false;
        }
        return true;
    }

    get confirmButtonText(): string {
        if(!(this.bookingTime && this.bookingDate)) {
            return 'Select date & time';
        } else {
            if(!this.fieldsCompleted) {
                return "Select payment method";
            }
        }
        return "Slide to confirm the bookings";
    }

    get activeCard(): any {
        return this.$store.getters['CreditCards/getActiveCard'];
    }

    get unitId(): number {
        return this.$store.getters['User/getPropertyId'];
    }

    get orders(): Array<Order> {
        return this.$store.getters['UnitFinance/getOrders'];
    }

    get bookingDate(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingDate'];
    }

    get bookingStartTime(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingStartTime'];
    }

    get bookingEndTime(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingEndTime'];
    }

    get bookingTime(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingTime'];
    }

    get bookingDuration(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingDuration'];
    }

    get bookingDurationValue(): number {
        const duration = Number(this.bookingDuration.slice(0, -1));
        const price = Number(this.facility.price);
        return (duration * price);
    }

    get vatValue(): number {
        return this.bookingDurationValue * 0.25;
    }

    get totalValue(): number {
        return this.bookingDurationValue + this.vatValue;
    }

    get bookingTimeDuration(): string {
        if(this.bookingTime && this.bookingDuration) {
            return `${this.bookingTime} (${this.bookingDuration})`;
        }
    }

    get isDateTimeFilled(): boolean {
        if (this.facility.requiredTimeSelect) {
            return (this.bookingDate !== '' && this.bookingDate !== null) && this.bookingTime !== '';
        } else {
            return (this.bookingDate !== '' && this.bookingDate !== null);
        }
    }

    get facility(): FacilityData {;
        return this.$store.getters['SharedFacilities/getUserSelectedFacility'];
    }

    get creditCards(): any {
        return this.$store.getters['CreditCards/getCreditCards'];
    }

    public creditCardIcon(brand): string {
        return `fab fa-cc-${brand}`;
    }

    public openDatePickerOverlay() {
        this.$store.commit(Mutations.SET_BOOK_FACILITY_DATE_OVERLAY_VISIBILITY, true);
    }

    public openTimePickerOverlay() {
        if (this.bookingDate === null) {
            return false;
        }

        this.$store.commit(Mutations.SET_BOOK_FACILITY_TIME_OVERLAY_VISIBILITY, true);
    }

    public cancel() {
        this.$store.commit(Mutations.SET_BOOK_FACILITY_OVERLAY_VISIBILITY, false);
        this.$store.commit(Mutations.RESET_FACILITY_BOOKING_TIME);
        this.$store.commit(Mutations.RESET_FACILITY_BOOKING_DATE);
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
        this.$store.commit(Mutations.SET_ACTIVE_CREDIT_CARD, null);
    }

    public beforeCreate() {
        this.$store.commit(Mutations.SET_HEADER_TEXT, 'Booking details');
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, 'BackButton');
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, false);
    }

    public created() {
        this.$store.dispatch(Actions.FETCH_USER_CREDIT_CARDS);
    }

    public beforeDestroy() {
        this.cancel();
    }

    public confirmBooking() {

        this.$store.commit(Mutations.SET_FACILITY_BOOKING_COST, this.totalValue);

        const charge = {
            form: {
                interval: '',
                charges: [
                    {
                        type: {
                            id: 22,
                            title: 'Service Fee'
                        },
                        text: this.facility.name,
                        amount: this.totalValue,
                        vat: false,
                        total: this.totalValue
                    }
                ],
                paymentDate: '2022-07-28',
                paymentEndDate: ''
            },
            unitId: this.unitId
        };

        this.$store.dispatch(Actions.ADD_ONE_TIME_CHARGE, charge).then((response) => {
            const { orders } = this;
            const order = orders[orders.length - 1];
            if(order) {
                const payment = {
                    orderId: order.id,
                    paymentMethodId: this.activeCard.id,
                };
                this.$store.dispatch(Actions.PAY_FOR_ORDER, payment).then(() => {
                    this.$store.dispatch(Actions.ADD_USER_BOOKING, {
                        date: this.bookingDate,
                        startTime: this.bookingStartTime,
                        endTime: this.bookingEndTime,
                        facilityId: this.facility.id,
                    });
                });
            }
        });
    }
}
